<template>
    <span>
        <div
        class="m-1 p-1"
        style="width: 10rem; text-align: center; position: relative;"
        :class="getClassList"
        @click="selectNotification(notification)"
        >
            <span v-show="hide_notification_count == false" style="" class="badge bg-danger rounded-pill notification_count">{{notification.length}}</span>
            <!--<div :class="selectedNotificationIndex == idx ? 'selected-notification' : ''" style="width: 100%; text-align: center;">
                <i style="font-size: 2rem;" class="fas" :class="notification.icon"></i>
            </div>-->
            <div :class="selected_index == notification.id ? 'selected-notification' : ''" style="width: 100%; text-align: center;">
                <i style="font-size: 2rem;" class="fas" :class="notification.icon"></i>
            </div>
            <div>
                <p class="text-capitalize text-truncate">{{notification.name}}</p>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    data:() => ({

    }),
    props:{
        is_notification:{
            default: false,
            type: Boolean,
        },
        notification:{},
        selected_index:{},
        hide_notification_count:{
            type: Boolean,
            default: false,
        }
    },
    computed:{
        getClassList(){
            let classes = '';
            if(this.is_notification){
                classes += ' notification-tile'
            }
            else{
                classes += ' info-tile'
            }
            // ------
            if(this.notification.length == 0){
                classes += ' no-notification'
            }
            return classes;
        }
    },
    methods:{
        selectNotification(notification){
            let payload = {
                notification: notification,
            }
            this.$emit('selectNotification', payload)
        }
    },
    mounted(){},
}
</script>

<style>

</style>